module.exports = __webpack_public_path__ + "static/media/student-score-losebox.390ac0d5.png";